import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/context/LanguageContext";

const ATTR_KEYS = ["fbclid", "ttclid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

// Auto-applies `?coupon=CODE` on any page and persists ad click ids before any redirect/navigation.
export default function PromoUrlHandler() {
  const { search } = useLocation();
  const { promo, applyPromo } = useCart();
  const { t } = useLang();
  const lastTried = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(search);
    ATTR_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) { try { sessionStorage.setItem(`audrivio_${k}`, v); } catch { /* storage disabled */ } }
    });
    const code = (params.get("coupon") || params.get("promo") || "").trim().toUpperCase();
    if (!code || promo?.code === code || lastTried.current === code) return;
    lastTried.current = code;
    applyPromo(code)
      .then((p) => toast.success(`${p.code}: ${t(p.kind === "gift" ? "promo_gift_applied" : "checkout_coupon_applied")}`))
      .catch((e) => toast.error(e.response?.data?.detail || t("checkout_coupon_invalid")));
  }, [search]); // eslint-disable-line

  return null;
}
